import Link from "next/link";
import { PRESS_COPY, PRESS_LANGS, pressPath, type PressLang } from "@/lib/press/kit";

type PressLanguageToggleProps = {
  lang: PressLang;
  variant?: "hero" | "footer";
};

const STYLES = {
  hero: {
    wrap: "bg-gray-100 dark:bg-gray-800",
    active: "bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm",
    idle: "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200",
    shape: "rounded-lg",
    button: "rounded-md",
  },
  footer: {
    wrap: "bg-slate-800/80 border border-slate-700/50",
    active: "bg-blue-600 text-white",
    idle: "text-slate-400 hover:text-slate-200 hover:bg-slate-700/50",
    shape: "rounded-full",
    button: "rounded-full",
  },
} as const;

/** Link-based language control for /press. Does not fire analytics. */
export function PressLanguageToggle({ lang, variant = "hero" }: PressLanguageToggleProps) {
  const styles = STYLES[variant];
  const label = PRESS_COPY[lang].languageLabel;

  return (
    <div
      className={`inline-flex items-center p-1 gap-1 ${styles.shape} ${styles.wrap}`}
      role="group"
      aria-label={label}
    >
      {PRESS_LANGS.map((item) => {
        const active = item === lang;
        return (
          <Link
            key={item}
            href={pressPath(item)}
            hrefLang={item}
            aria-current={active ? "true" : undefined}
            className={`px-3 py-1.5 text-sm font-medium transition-colors ${styles.button} ${
              active ? styles.active : styles.idle
            }`}
          >
            {item.toUpperCase()}
          </Link>
        );
      })}
    </div>
  );
}
